import type { ReactElement } from "react"
import { useCallback } from "react"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import _t from "@core/i18n"
import { closePlanOverLimitModal } from "~/store/basket/actions"
import { isPlanOverLimitModalOpen } from "~/store/basket/selectors"
import { useAppDispatch, useAppSelector } from "~/store/hooks"
import ModalTemplateWrapper from "../ModalTemplateWrapper"

export default function PlanOverLimitModal(): ReactElement {
  const dispatch = useAppDispatch()
  const isOpen = useAppSelector(isPlanOverLimitModalOpen)

  const handleClose = useCallback((): void => {
    dispatch(closePlanOverLimitModal())
  }, [dispatch])

  return (
    <ModalTemplateWrapper
      isOpen={isOpen}
      onCloseButtonClick={handleClose}
      content={
        <>
          <TextAtm pushSpace={2} typography="large3">
            {_t("modal.planOverLimit.title")}
          </TextAtm>

          <TextAtm typography="medium1_h">
            {_t("modal.planOverLimit.description")}
          </TextAtm>
        </>
      }
      buttons={[
        {
          onClick: handleClose,
          title: _t("modal.planOverLimit.button"),
          text: _t("modal.planOverLimit.button"),
          color: "success",
        },
      ]}
    />
  )
}
